/** @type {Window & { umami?: { identify?: (payload: Record<string, string>) => void } }} */
const analyticsWindow = window;

/**
 * @param {{ id?: string | number | null } | null | undefined} user
 * @param {{ role?: string | null } | null | undefined} profile
 */
export const identifyLoggedInUserWithUmami = (user, profile) => {
  const id = String(user?.id ?? '')
    .trim()
    .slice(0, 50);
  if (!id || typeof analyticsWindow?.umami?.identify !== 'function') {
    return;
  }

  /** @type {Record<string, string>} */
  const payload = { id };
  const role = String(profile?.role ?? '').trim();
  const firstName = String(profile?.firstName ?? '').trim();
  const lastName = String(profile?.lastName ?? '').trim();
  const tenant = String(localStorage.getItem('REALM_ID') ?? '').trim();
  if (role) payload.role = role;
  if (firstName) payload.firstName = firstName;
  if (lastName) payload.lastName = lastName;
  if (tenant) payload.tenant = tenant;

  analyticsWindow.umami.identify(payload);
};
